module.exports = __webpack_public_path__ + "static/media/sectur.ca7949c9.png";